/**
 * ユーザーのWebサイトに埋め込みでVoice Agentを表示させるためのスクリプト
 */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import embeddedRender from "./utils/embeddedRender";
import EmbeddingVoiceAgent from "@/components/embedding/EmbeddingVoiceAgent";
import { setBaseURL } from "@/lib/api/custom-client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

declare global {
  // eslint-disable-next-line no-var
  var OMAKASE_VOICE_DD: unknown; // isDuplicated
}

(() => {
  /**
   * Execution
   */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }

  /**
   * Functions
   */
  async function main() {
    // 排他制御
    if (typeof window.OMAKASE_VOICE_DD !== "undefined") {
      throw new Error(`OMAKASE_VOICE のスクリプトが重複しています`);
    } else {
      window.OMAKASE_VOICE_DD = true;
    }

    // API URLの設定
    const config = getConfig();
    if (config?.apiUrl) {
      setBaseURL(config.apiUrl);
    }

    // レンダリング
    if (config) {
      // モーダル用のコンテナ要素を作成
      const modalContainer = document.createElement("div");
      modalContainer.id = "showcan-voice-modal-container";
      document.body.appendChild(modalContainer);

      embeddedRender(
        <QueryClientProvider client={queryClient}>
          <EmbeddingVoiceAgent agentId={config.agentId} />
        </QueryClientProvider>,
        {
          parent: document.body,
        }
      );
    }
  }

  type EmbedConfig = {
    agentId: string;
    apiUrl?: string;
  };

  /**
   * スクリプトの設定を取得
   */
  function getConfig(): EmbedConfig | null {
    const script = document.getElementById("showcan-voice-embed-script");

    // Agent IDを取得
    const agentId = script?.getAttribute("data-agent-id");
    if (!agentId) {
      console.warn("OMAKASE_VOICE: data-agent-id is required");
      return null;
    }

    // API URLを取得
    const apiUrl = script?.getAttribute("data-api-url") || undefined;

    return {
      agentId,
      apiUrl,
    };
  }
})();
